module.exports = __webpack_public_path__ + "img/pt.pt9647512.svg";